<script setup lang="ts">
import { type StoreName } from '@bluebrick/discounts-service-module'
import { Tooltip } from '@bluebrick/saas-ui'
import { computed } from 'vue'
import { StoreToPortalFunctionality, type PortalFunctionality } from '@/common/utils'
import type { Portal } from '@/types'

const props = defineProps<{
	storeName: StoreName
	portal: Portal
	type: PortalFunctionality
}>()

const functionalities = StoreToPortalFunctionality.get(props.storeName)

const portalFunctionalityData: Record<PortalFunctionality, { tooltip: string; icon: string }> = {
	discountDepth: { tooltip: 'Advice on discount depth', icon: 'sale-outline' },
	eventPerformance: { tooltip: 'Event performance summary', icon: 'chart-line-variant' },
	manualEvents: { tooltip: 'Manual timeline events setup', icon: 'calendar-multiselect' },
	pastScraper: { tooltip: 'Past event scraper', icon: 'progress-download' },
	scheduling: { tooltip: 'Advice on scheduling', icon: 'subtitles-outline' }
}

const fillColorStyleVar = computed(() => ({
	'--portal-functionality-color': `var(--color-portal-${props.portal}-primary)`
}))
</script>

<template>
	<Tooltip :content="portalFunctionalityData[type].tooltip" placement="top">
		<mdicon
			:name="portalFunctionalityData[type].icon"
			:class="[`portalFunctionality`, 'icon--size-1', { 'portalFunctionality--disabled': !functionalities?.has(type) }]"
			:style="fillColorStyleVar"
		/>
	</Tooltip>
</template>

<style scoped lang="scss">
.portalFunctionality {
	:deep(svg) {
		width: 1rem;
		height: 1rem;
	}

	color: var(--portal-functionality-color);

	&.portalFunctionality--disabled {
		color: theme('colors.ink.12');
	}
}
</style>
